













import { Component, Vue } from 'vue-property-decorator';
import {pubsub, DELETE_TODO_EVENT} from '@/utils/pubsub';
import { todoListInstance } from '@/model/TodoListClass';

type ITodoInfo = ITodo.IResponse.ITodoInfo;
type ActiveKey = 'delete' | 'close' | '';
interface IOperationModalConfig {
  title: string;
  todo: ITodoInfo;
  activeKey: ActiveKey;
}

@Component
export default class TodoOperationModal extends Vue {
  private visible = false;
  private title = '';
  private todo: ITodoInfo | null = null;
  private activeKey: ActiveKey = '';
  private note = '';
  private confirmLoading = false;
  public showVisible(config: IOperationModalConfig) {
    this.title = config.title;
    this.todo = config.todo;
    this.activeKey = config.activeKey;
    this.visible = true;
  }
  private onClose() {
    this.note = '';
    this.visible = false;
    this.activeKey = '';
  }
  private onOk() {
    if (this.activeKey === 'close') {
      this.submitByClose();
    } else if (this.activeKey === 'delete') {
      this.submitByDelete();
    }
  }
  private submitByDelete() {
    if (!this.todo) {
      return;
    }
    this.confirmLoading = true;
    todoListInstance.requestUndoTodo(this.todo, this.note).then((res) => {
      this.$message.success(res);
      pubsub.publish(DELETE_TODO_EVENT, this.todo);
      this.onClose();
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.confirmLoading = false;
    });
  }
  private submitByClose() {
    if (!this.todo) {
      return;
    }
    const note = this.note.trim();
    if (note.length < 1) {
      this.$message.warning(this.$t('todo.remarkTips').toString());
      return;
    }
    this.confirmLoading = true;
    todoListInstance.requestUpdateTodoStatus(this.todo, 'Closed', note).then((res) => {
      this.$message.success(res);
      this.onClose();
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.confirmLoading = false;
    });
  }
}
